module.exports = __webpack_public_path__ + "img/infographicWhoWeAreHorisontalHome.5010b37f.png";